import React from 'react';
import {Box, Stack} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import LabelledMuiTypography from "../../../../../ui/mui/mui-display-data/LabelledMuiTypography";
import useApiGetSchedaCostoDetail from "./api-hooks/useApiGetSchedaCostoDetail";
import MotionDivider from "../../../../../ui/MotionDivider";

interface Props {
    order_id?: number,
}

const SchedaCostoWorkingsCard = ({order_id: order_id}: Props) => {
    const theme = useTheme();
    const fontSize = 18;

    const {data: detailedObj, isSuccess, isFetched} = useApiGetSchedaCostoDetail(order_id);

    return (
        <Box component="fieldset" sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            border: '1px solid lightgrey',
            borderRadius: '4px',
            padding: '10px',
            backgroundColor: theme.palette.backgroundAppGarageColor.main
        }}>
            <legend style={{
                padding: '0 8px',
                color: theme.palette.primary.main,
                fontWeight: 500
            }}>
                Lavorazioni Interne
            </legend>

            {detailedObj?.workings && detailedObj.workings.length > 0 ? (
                <Stack spacing={1} width="100%">
                    {detailedObj.workings.map((working, index) => (
                        <Box key={working.id}>
                            <LabelledMuiTypography
                                label={'Lavorazione'}
                                value={working.product_name}
                                upperCaseValue={false}
                                fontSize={fontSize}
                            />
                            <LabelledMuiTypography
                                label={'Quantità'}
                                value={`${working.quantity?.toFixed(2)} ${working.um}`}
                                upperCaseValue={false}
                                fontSize={fontSize}
                            />
                            <LabelledMuiTypography
                                label={'Prezzo Unitario'}
                                value={`${working.price_value?.toFixed(2)} €`}
                                upperCaseValue={false}
                                fontSize={fontSize}
                            />
                            <LabelledMuiTypography
                                label={'Costo Totale'}
                                value={`${working.total_cost?.toFixed(2)} €`}
                                upperCaseValue={false}
                                fontSize={fontSize}
                            />
                            {working.working_description && (
                                <LabelledMuiTypography
                                    label={'Descrizione'}
                                    value={working.working_description}
                                    upperCaseValue={false}
                                    fontSize={fontSize}
                                />
                            )}
                            {index < detailedObj.workings.length - 1 && <MotionDivider/>}
                        </Box>
                    ))}
                </Stack>
            ) : (
                <LabelledMuiTypography
                    label={'Nessuna lavorazione'}
                    value={''}
                    upperCaseValue={false}
                    fontSize={fontSize}
                />
            )}
        </Box>
    );
}

export default SchedaCostoWorkingsCard;